import router from '@/router'
import {
    Auth,
    API,
    graphqlOperation
} from 'aws-amplify';
import {
    listDistributors,
    listDistributorUsers,
    listUsers,
    listOwners,
    getUser,
    locationByCode,
    userByCode
} from '@/graphql/queries'
import {
    listUsersByDistributor,
    getUserDevices
    // listUsersByOwner
} from "@/store/custom"
import {
    approveUser
} from '@/graphql/mutations'
import {
    path
} from "ramda"
const state = {
    user: "",
    userDetails: "",
    state: "signIn",
    pending: false,
    users: [],
    loading: false,
    userSearch: ""
}

const getters = {
    userDistributorName(state) {
        if (!path(["state", "user", "attributes", "custom:distributor"], state)) {
            return "NA"
        } else return state.user.attributes["custom:distributor"]
    },
    userDistributorId(state) {
        if (!path(["state", "user", "attributes", "custom:distributor"], state)) {
            return "NA"
        } else return state.user.attributes["custom:distributor"]
    },
    userStoreName(state) {
        if (!path(["state", "user", "attributes", "custom:store"], state)) {
            return "NA"
        } else return state.user.attributes["custom:store"]
    },
    userId(state) {
        return state.user.username
    },
    // userDistributorId(state) {
    //     return state.user.attributes["custom:distributor"]
    // },
    isAuthenticated(state) {
        return !!state.user
    },
    isSuper(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "super") return true
        else return false
    },
    isDistributor(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "distributor") return true
        else return false
    },
    isStore(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "store") return true
        else return false
    },
    isAdmin(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "admin") return true
        else return false
    },
    isUser(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "user") return true
        else return false
    },
    isLocation(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "location") return true
        else return false
    },
    isCustomer(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "customer") return true
        else return false
    },
    isMDX(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "mdx") return true
        else return false
    },
    isKDX(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "kdx") return true
        else return false
    },
    isTDX(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "tdx") return true
        else return false
    },
    isFuelCell(state) {
        if (!state.user) return
        if (state.user.attributes["custom:auth"] === "fuelcell") return true
        else return false
    },
    isPending(state) {
        return state.pending
    }
}

const actions = {
    async login({
        commit,
        dispatch
    }, user) {
        commit("setUser", user)
        return
    },
    async logout({
        commit
    }) {
        await Auth.signOut({
            global: true
        })
        commit("removeUser")
        router.push('/login')
    },
    async getDistributorUsers({
        commit,
        dispatch
    }, dist) {
        const {
            data: {
                listUsers: {
                    items
                }
            }
        } = await API.graphql(graphqlOperation(listUsersByDistributor, {
            filter: {
                auth: {
                    ne: "super"
                }
            },
            limit: 1000
        }))
        let allUsers = items.filter(item => {
            if (item.auth === "distributor") {
                return item.distributor.name === dist
            } else if (item.auth === "store") {
                return item.store.distributor.name === dist
            } else if (item.auth === "user") {
                return item.location.store.name === dist
            }
        })
        commit("setUsers", allUsers)
        // commit("setUsers", await dispatch("filterDistributorUsers", items[0]))
    },
    // async getOwnerUsers({
    //     commit,
    //     dispatch
    // }, owner) {
    //     const {
    //         data: {
    //             listOwners: {
    //                 items
    //             }
    //         }
    //     } = await API.graphql(graphqlOperation(listUsersByOwner, {
    //         filter: {
    //             name: {
    //                 eq: owner
    //             }
    //         }
    //     }))
    //     commit("setUsers", await dispatch("filterUsers", items[0].users.items))
    // },
    async getAllUsers({
        commit,
        dispatch
    }) {
        const {
            data: {
                listUsers: {
                    items
                }
            }
        } = await API.graphql(graphqlOperation(listUsers, {
            limit: 1000
        }))
        commit("setUsers", await dispatch("filterSuperUsers", items))
    },
    async getUserDetails({
        commit,
        dispatch
    }, id) {
        const {
            data
        } = await API.graphql({
            query: getUser,
            variables: {
                id
            }
        })
        commit("setUserDetails", data.getUser)
        return data.getUser
    },
    async getLocationCode({}, code) {
        const {
            data
        } = await API.graphql({
            query: locationByCode,
            variables: {
                code
            }
        })
        if (data.locationByCode.items.length) return data.locationByCode.items[0].id
        else return false
    },
    async getUserCode({}, code) {
        const {
            data
        } = await API.graphql({
            query: userByCode,
            variables: {
                code
            }
        })
        if (data.userByCode.items.length) return data.userByCode.items[0].id
        else return false
    },
    async getAllUserDevices({
        commit,
        dispatch
    }, id) {
        const {
            data
        } = await API.graphql({
            query: getUserDevices,
            variables: {
                id
            }
        })
        commit("setUserDetails", data.getUser)
        return data.getUser
    },
    async filterDistributorUsers({}, users) {
        let all = []
        console.log(users)
        users.owners.items.forEach(item => {
            all.push(item)
        })
        users.stores.items.forEach(item => {
            item.admins.items.forEach(item => {
                all.push(item)
            })
        })
        console.log(all)
    },
    async filterSuperUsers({}, users) {
        return users.map(item => {
            let distributor = "NA"
            let location = "NA"
            // if (auth === "distributor") {
            //     distributor = item.
            // }
            return {
                id: item.id,
                first: item.first,
                last: item.last,
                email: item.email,
                auth: item.auth,
                distributor: distributor,
                location: location,
                approved: item.approved
            }
        })
    },

    async checkUser({
        commit,
        state,
        dispatch
    }) {
        try {
            let user = await Auth.currentAuthenticatedUser()
            await dispatch("getUserDetails", user.username)
            commit("setUser", user)
            return true
        } catch (error) {
            return false
        }
    },
    async checkUserPermission({
        commit,
        state,
        dispatch
    }) {
        try {
            let user = await Auth.currentAuthenticatedUser()
            let { auth } = await dispatch("getUserDetails", user.username)
            commit("setUser", user)
            return auth
        } catch (error) {
            return false
        }
    },
    async pendingUser({
        commit
    }) {
        commit("setPending", true)
    },
    async approveUserRegistration({
        commit
    }, user) {
        const {
            data
        } = await API.graphql(graphqlOperation(approveUser, {
            userId: user.id,
            userEmail: user.email
        }))
        if (data.approveUser) {
            commit("updateApproveUser", user.id)
        } else {
            console.log("User could not be verified")
        }
    },
    async disableUserRegistration({
        commit
    }, id) {
        const {
            data
        } = await API.graphql(graphqlOperation(disableUser, {
            userId: id
        }))
        if (data.approveUser) {
            commit("updateApproveUser", user.id)
        } else {
            console.log("User could not be verified")
        }
    }
}

const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setUserDetails(state, details) {
        state.userDetails = details
    },
    updateApproveUser(state, userId) {
        let index = state.users.findIndex(item => item.id === userId)
        state.users[index].approved = true
    },
    setState(state, userState) {
        state.state = userState
    },
    removeUser(state) {
        state.user = ""
    },
    setPending(state) {
        state.pending = true
    },
    setUsers(state, users) {
        state.users = users
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setSearch(state, val) {
        state.userSearch = val
    },
    removeSearch(state) {
        state.userSearch = ""
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}